import { Layout } from "components"
export const MacroControl = () => {
 return (
  <Layout>
   <h1 className="flex justify-center py-5 text-xl font-bold">Macro Control</h1>
  </Layout>
 )
}
